import React from 'react';
import StandardDropdown from 'Common/Components/StandarDropdown';
import { useSelector } from 'react-redux';
import { selectActions } from 'store/Jobs/selectors';
import { PropTypes } from 'prop-types';
import Warning from '../Warning';
import { Wrapper, Label } from './styled';

const ActionSelector = ({ value, onChange }) => {
  const options = useSelector(selectActions);

  return (
    <Wrapper>
      <Label>Action</Label>
      <StandardDropdown
        width="200px"
        field="action"
        options={ options }
        updateValue={ (f, v) => onChange(v) }
        defaultValue={ value }
        selectObject
      />
      { value === 'delete' && <Warning /> }
    </Wrapper>
  );
};

ActionSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ActionSelector;
